var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 162,
    viewBox: "0 0 156 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.773 51.8278H56.9969V110.645H105.833C106.153 108.101 106.514 105.276 106.934 101.971H149V90L156 101.971V140.875C153.558 141.195 150.266 141.576 146.823 142.037C146.523 144.882 146.223 147.706 145.863 151.112C142.72 151.352 139.898 151.573 136.736 151.813C136.436 155.259 136.175 158.103 135.915 161.068H33L30 149H13L10 139.5V129L3 128L0 119V32.2555H16.2268V11.9819H145.442L149 10L156 21.9985V60.6527L107.174 60.9028C106.774 58.2785 106.333 55.4738 105.773 51.8478V51.8278Z",
    fill: "#F86C14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.773 39.8459H49.9969V98.6631H98.833C99.1533 96.1189 99.5135 93.2942 99.9339 89.9887H149V128.893C146.558 129.214 143.266 129.594 139.823 130.055C139.523 132.9 139.223 135.724 138.863 139.13C135.72 139.37 132.898 139.591 129.736 139.831C129.436 143.277 129.26 146.035 129 149H30L29.0438 139.577L10 139.5V120C10 120 0 119 0 118.997V20.2735C2.60192 19.8528 5.40399 19.3921 9.22682 18.771V0H138.442C138.883 2.44404 139.363 5.22864 139.983 8.6543C142.505 9.05497 145.577 9.4957 149 10.0166V48.6708L100.174 48.9209C99.7737 46.2965 99.3334 43.4919 98.773 39.8659V39.8459Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.6f449c582221e1412cc5cc791f508fa2.svg";
export { ForwardRef as ReactComponent };